import clsx from 'clsx'
import React, { useContext } from 'react'

const roundedStyles = 'first:rounded-t-lg last:rounded-b-lg'
const borderStyles = 'first:border-t last:border-b border-x border-subdued'

type CardProps = {
  children?: React.ReactNode
  className?: string
  withBorder?: boolean
}

const CardContext = React.createContext({ withBorder: false })

export function Card({ children, className, withBorder, ...props }: CardProps) {
  return (
    <CardContext.Provider value={{ withBorder }}>
      <section className={className} {...props}>
        {children}
      </section>
    </CardContext.Provider>
  )
}

type CardHeaderProps = {
  children?: React.ReactNode
  className?: string
}
export function CardHeader({ children, className }: CardHeaderProps) {
  const { withBorder } = useContext(CardContext)

  return (
    <header
      className={clsx(
        'p-6 bg-surface-selected-default rounded-t-lg items-center',
        roundedStyles,
        withBorder && borderStyles,
        className
      )}
    >
      {children}
    </header>
  )
}

type CardBodyProps = {
  children?: React.ReactNode
  className?: string
  withSeparator?: boolean
}
export function CardBody({
  children,
  className,
  withSeparator,
}: CardBodyProps) {
  const { withBorder } = useContext(CardContext)

  return (
    <div
      className={clsx(
        'bg-white',
        roundedStyles,
        withBorder && borderStyles,
        withSeparator && 'border-t',
        className
      )}
    >
      {children}
    </div>
  )
}

type CardFooterProps = {
  children?: React.ReactNode
  className?: string
  withSeparator?: boolean
}
export function CardFooter({
  children,
  className,
  withSeparator = true,
}: CardFooterProps) {
  const { withBorder } = useContext(CardContext)

  return (
    <footer
      className={clsx(
        'bg-white flex p-5 border-subdued',
        withSeparator && 'border-t',
        withBorder && borderStyles,
        roundedStyles,
        className
      )}
    >
      {children}
    </footer>
  )
}
